import React, { createContext, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

// Create a context with default value null
const NativeLayerContext = createContext(null);

export function NativeLayerProvider({ children }) {
    const [auth0IdToken, setAuth0IdToken] = useState(null);
    const [nativeFunctionalityOverrides, setNativeFunctionalityOverrides] =
        useState(null);
    const [platform, setPlatform] = useState(false);

    const [searchParams] = useSearchParams();

    useEffect(() => {
        const hasNativeAuth = searchParams.has('nativeAuth');
        const platforms = hasNativeAuth ? searchParams.get('source') : null;

        if (platforms) {
            setPlatform(platforms);
        }
    }, []);

    useEffect(() => {
        const messageListener = (rawNativeEvent) => {
            const nativeEvent = rawNativeEvent.detail;
            switch (nativeEvent.type) {
                case 'SET_ID_TOKEN':
                    if (nativeEvent.auth0IdToken !== auth0IdToken) {
                        setAuth0IdToken(nativeEvent.auth0IdToken);
                    }
                    break;
                case 'SET_FUNCTIONALITY_OVERRIDES':
                    setNativeFunctionalityOverrides(
                        nativeEvent.nativeFunctionalityOverrides,
                    );
                    break;
                default:
                    console.error('Unknown native event:', rawNativeEvent);
                    break;
            }
        };

        // Add event listener for custom nativeEvent
        document.addEventListener('nativeEvent', messageListener);

        // Clean up
        return () => {
            document.removeEventListener('nativeEvent', messageListener);
        };
    }, [auth0IdToken]);

    const contextValue = {
        auth0IdToken,
        nativeFunctionalityOverrides,
        platform,
    };

    return (
        <NativeLayerContext.Provider value={contextValue}>
            {children}
        </NativeLayerContext.Provider>
    );
}

export default NativeLayerContext;
